import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import '@/assets/fonts/flaticon.css' 
import fr from '@/i18n/fr'

Vue.use(Vuetify);

export default new Vuetify({   
    theme: { dark: false},
    icons: {
        //iconfont: "flaticon"
    },
    lang: {
        locales: { fr },
        current: 'fr',
    },
})
